// src/i18n/es/notAuthorized.ts
export const notAuthorized = {
  title: 'No autorizado',
  description: 'No tiene permisos para acceder a este recurso.',
  backHome: 'Volver al inicio',
};

export default notAuthorized;
